export default {
  state: () => ({
    info: undefined
  }),
  mutations: {
    ['SET_INFO'](state, payload) {
      state.info = payload
    }
  },
  actions: {},
  getters: {}
}
